<script>
	export let layout;
	$: plot = layout.plot;
	const px = (v) => Math.round(v) + 0.5;
</script>

{#each layout.refLines as r}
	{#if layout.horizontal}
		<line class="ref" x1={px(r.pos)} x2={px(r.pos)} y1={plot.y} y2={plot.y + plot.h} />
		<text class="refLabel" x={r.pos + 4} y={plot.y + 11}>{r.label}<title>{r.full || r.label}</title></text>
	{:else}
		<line class="ref" x1={plot.x} x2={plot.x + plot.w} y1={px(r.pos)} y2={px(r.pos)} />
		<text class="refLabel" x={r.left ? plot.x + 4 : plot.x + plot.w} y={r.pos - 5} text-anchor={r.left ? "start" : "end"}>{r.label}<title>{r.full || r.label}</title></text>
	{/if}
{/each}

{#each layout.notes as n}
	{@const below = n.y - 32 < plot.y}
	<circle class="noteDot" cx={n.x} cy={n.y} r="4" style="--c:{n.color}" />
	<line class="leader" x1={n.x} y1={below ? n.y + 7 : n.y - 7} x2={n.x} y2={below ? n.y + 22 : n.y - 22} />
	<text class="note" x={n.flip ? n.x - 6 : n.x + 6} y={below ? n.y + 26 : n.y - 25} text-anchor={n.flip ? "end" : "start"} dominant-baseline={below ? "hanging" : "auto"}>{n.label}<title>{n.full || n.label}</title></text>
{/each}

<style>
	.ref {
		stroke: var(--_ink-muted);
		stroke-width: 1.5;
		shape-rendering: crispEdges;
	}

	.refLabel,
	.note {
		fill: var(--_ink-muted);
		font-size: 11px;
		paint-order: stroke;
		stroke: var(--_surface);
		stroke-width: 3px;
		stroke-linejoin: round;
	}

	.note {
		fill: var(--_ink);
		font-weight: 600;
	}

	.leader {
		stroke: var(--_ink-muted);
		stroke-width: 1;
	}

	.noteDot {
		fill: var(--c);
		stroke: var(--_ink);
		stroke-width: 2;
	}
</style>
